<script>
  import { format } from 'svelte-i18n';
  import { Button, TabContent, TabPane, Tooltip } from '@sveltestrap/sveltestrap';
  import { formatDistanceToNow } from 'date-fns';

  import { CodeMirror } from '@client/components/codemirror';
  import { Icon } from '@client/components/icon';
  import { Spinner } from '@client/components/spinner';

  import { SignaturesService } from '@client/services/signatures';

  import { DefaultSignature } from './default-signature';

  export let data = {};
  export let border = false;

  const getDefaultSignatures = async (userConfig) => {
    const email = userConfig.email;
    const result = {};
    const plaintext = await SignaturesService.generatePlainTextSignature({ email });

    try {
      if (userConfig.google) {
        const response = await SignaturesService.getDefaultSignatures(email, email, 'gapps');
        result.google = {
          email,
          label: 'Gmail',
          id: 'gapps',
          lastUsedTimestamp: userConfig.sigcompliance?.gmail
            ? formatDistanceToNow(new Date(userConfig.sigcompliance.gmail), { addSuffix: true })
            : $format('label.NEVER'),
          signature: response.signature,
          plaintext: plaintext?.sigblock || '',
          data: userConfig?.google,
          editing: false
        };
      }

      if (userConfig.office365) {
        const response = await SignaturesService.getDefaultSignatures(email, email, 'o365');

        result.office365 = {
          email,
          label: 'Office',
          id: 'o365',
          lastUsedTimestamp: userConfig.sigcompliance?.desktop
            ? formatDistanceToNow(new Date(userConfig.sigcompliance.desktop), { addSuffix: true })
            : $format('label.NEVER'),
          signature: response.result,
          plaintext: plaintext?.sigblock || '',
          data: userConfig?.office365,
          editing: false
        };
      }

      if (userConfig.outreach) {
        const response = await SignaturesService.getDefaultSignatures(email, email, 'outreach');

        result.outreach = {
          email,
          label: 'Outreach',
          id: 'outreach',
          lastUsedTimestamp: userConfig.sigcompliance?.outreach
            ? formatDistanceToNow(new Date(userConfig.sigcompliance.outreach), { addSuffix: true })
            : $format('label.NEVER'),
          signature: response?.data?.attributes?.emailSignature,
          plaintext: plaintext?.sigblock || '',
          data: userConfig?.outreach,
          editing: false
        };
      }
    } catch (err) {
      console.log(err);
    }

    return result;
  };
</script>

{#await getDefaultSignatures(data)}
  <div class="section-loading">
    <Spinner show inline />
  </div>
{:then defaultSignatures}
  {#if Object.entries(defaultSignatures).length}
    <div id="default-signature-field" class="fields">
      <h2 class="heading">
        {$format('label.DEFAULT_SIGNATURES')}
        <Icon name="help-circle" id="signatures-tooltip" class="cursor-help h5" />
        <Tooltip target="signatures-tooltip" placement="top">
          {$format('label.TOOLTIP.DEFAULT_SIGNATURES')}
        </Tooltip>
      </h2>
      <p class="pb-3">
        {@html $format('label.DESCRIPTION.DEFAULT_SIGNATURES')}
      </p>

      <div class:content={border} class="mb-4">
        <TabContent pills>
          {#each Object.entries(defaultSignatures) as [key, config], index}
            <TabPane tabId={key} tab={config.label} active={index === 0}>
              <DefaultSignature bind:config />
            </TabPane>
          {/each}
        </TabContent>
      </div>
    </div>
  {:else}
    <div class="fields">&nbsp;</div>
  {/if}
{:catch error}
  <p style="color: red">{error.message}</p>
{/await}

<style lang="scss" src="./default-signatures.scss"></style>
